DJ.addBehavior('js-filter-carousel', '.js-filter-carousel', {
  attach: function(context, settings, behavior) {
    const $carousel = jQuery('.js-filter-carousel');

    // Convertir data-items en nombre et vérifier si >= 5 (cohérent avec le template)
    const itemsCount = parseInt($carousel.data('items'), 10) || 0;
    const showArrows = itemsCount >= 5;

    $carousel.slick({
      variableWidth: true,
      arrows: showArrows,
      dragging: true,
      infinite: false,
      prevArrow: '<button class="slick-prev" type="button">Précédent</button>',
      nextArrow: '<button class="slick-next" type="button">Suivant</button>',
    });
  },

  detach: function(context, settings) {}
});
